var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit, Prop } from "vue-property-decorator";
import { RepairCasesService } from "~/services/domain-service/repair-cases.service";
import FileUpload from "~/components/common/file-upload.vue";
var RepairInfoUpload = /** @class */ (function (_super) {
    __extends(RepairInfoUpload, _super);
    function RepairInfoUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileList = [];
        _this.modifyModel = {
            caseId: "",
            fileIds: [],
            repairMemo: ""
        };
        _this.rules = {
            fileIds: { required: true, message: "请上传附件" },
            repairMemo: { required: true, message: "请输入修复说明" }
        };
        return _this;
    }
    RepairInfoUpload.prototype.emitClose = function () {
        var form = this.$refs['modify-form'];
        form.resetFields();
        this.fileList = [];
    };
    RepairInfoUpload.prototype.emitSuccess = function () {
        this.$message.success("操作成功");
        this.emitClose();
    };
    RepairInfoUpload.prototype.commit = function () {
        var _this = this;
        this.modifyModel.caseId = this.id;
        this.modifyModel.fileIds = this.fileList.map(function (v) { return v.response.id; });
        var form = this.$refs['modify-form'];
        form.validate(function (v) {
            if (!v)
                return;
            _this.repairCasesService.toRepair(_this.modifyModel).subscribe(_this.emitSuccess);
        });
    };
    __decorate([
        Dependencies(RepairCasesService)
    ], RepairInfoUpload.prototype, "repairCasesService", void 0);
    __decorate([
        Prop({ required: true })
    ], RepairInfoUpload.prototype, "id", void 0);
    __decorate([
        Emit("close")
    ], RepairInfoUpload.prototype, "emitClose", null);
    __decorate([
        Emit("success")
    ], RepairInfoUpload.prototype, "emitSuccess", null);
    RepairInfoUpload = __decorate([
        Component({
            components: {
                FileUpload: FileUpload
            }
        })
    ], RepairInfoUpload);
    return RepairInfoUpload;
}(Vue));
export default RepairInfoUpload;
